import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { BookOpen, Users, GraduationCap, FileText, PenTool, Mail } from "lucide-react";
const Index = () => {
  const navigate = useNavigate();
  const portfolioSections = [{
    id: "resilience-models",
    title: "מודלים לחוסן וליווי",
    shortDescription: "כלים ומתודולוגיות לחיזוק החוסן הנפשי והרגשי",
    fullDescription: "בדף זה מוצגים מודלים ישומיים לליווי רגשי ולחיזוק חוסן אישי וקבוצתי, שפותחו מתוך עבודה ארוכת שנים עם אנשי חינוך, מנהלים ונוער. המודלים משלבים התבוננות פנימית, עבודה קבוצתית וכלים מעשיים המאפשרים תהליכי עומק רכים, מותאמים לשדה החינוכי והקהילתי.",
    icon: BookOpen,
    color: "bg-cyan-100 hover:bg-cyan-200"
  }, {
    id: "professional-training",
    title: "תכניות והשתלמויות",
    shortDescription: "תוכניות הכשרה ופיתוח מקצועי לצוותים",
    fullDescription: "דף זה מציג תכניות והשתלמויות לפיתוח צוותי חינוך, מתוך שילוב בין ידע פדגוגי, ניסיון ניהול והבנה עמוק של תהליכי שינוי. התכניות בנויות כתהליכים מתמשכים, משלבות למידה, התנסות ורפלקציה, ומותאמות למציאות החינוכית המשתנה.",
    icon: Users,
    color: "bg-emerald-100 hover:bg-emerald-200"
  }, {
    id: "school-projects",
    title: "פרוייקטים חינוכיים",
    shortDescription: "דוגמאות להובלה ויישום של פרוייקטים חינוכיים",
    fullDescription: "כאן מוצגים פרוייקטים בית ספריים שהובלתי, משלב תכנון והחזון ועד ליישום בשטח. הפרוייקטים משקפים תפיסה חינוכית המבוססת על שותפות, בניית ארגוני תרבות והנעת צוות לאורך זמן. שמות ילדים ותמונותיהם טושטשו או הוסרו, בהתאם לכללי אתיקה וחיסיון.",
    icon: GraduationCap,
    color: "bg-violet-100 hover:bg-violet-200"
  }, {
    id: "monthly-pages",
    title: "דפי קהילה",
    shortDescription: "דוגמאות לתוכן חודשי לחיזוק קשרי קהילה",
    fullDescription: "בדף זה מוצגים דפים חודשיים שנכתבו לקהילת בית הספר. הדפים נועדו על מנת לחזק את החיבור עם הקהילה. ולתרגם ערכים חינוכיים למסרים, נגישים ומעוררי מחשבה.",
    icon: FileText,
    color: "bg-amber-100 hover:bg-amber-200"
  }, {
    id: "narrative-writing",
    title: "כתיבה נרטיבית לארגונים",
    shortDescription: "שימוש בכתיבה יצירתית לשינוי ארגוני והשראה",
    fullDescription: "דף זה מציג דוגמאות לכתיבה נרטיבית לארגונים ולקהילות. כתיבה נרטיבית היא תרגום רעיון לסיפור אנושי, בדרך שהקורא ירצה להמשיך לקרוא. כתיבה כזו מאפשרת לארגונים להפוך מידע מורכב למסרים בהירים המעוררים רגש ומחדדים את הזהות והחזון של הארגון. הדוגמאות המוצגות בסעיף זה נכתבו עבור ארגונים ויוזמות שונות. שמות הארגונים לא פורסמו, לשמירה על פרטיות.",
    icon: PenTool,
    color: "bg-teal-100 hover:bg-teal-200"
  }, {
    id: "awards",
    title: "תעודות הוקרה",
    shortDescription: "הכרה מקצועית והסמכות בתחום החינוך",
    fullDescription: "בדף זה מרוכזים פרסים, תעודות והסמכות שניתנו לאורך השנים כהוקרה על הובלת תהליכים חינוכיים- ארגוניים. הם משקפים הערכה חיצונית לעשייה מתמשכת, ערכית ומבוססת דרך.",
    icon: Mail,
    color: "bg-pink-100 hover:bg-pink-200"
  }, {
    id: "inspiration",
    title: "דף השראה",
    shortDescription: "השראה אישית וראייה מקצועית",
    fullDescription: "דף זה הוא מרחב התבוננות אישי שלי המספר סיפור דרך. כאן נפרשת תפיסת עולמי המקצועית והאנושית. והקשרים שנוצרו בין חוויות חיים, עשייה חינוכית ובחירה מתמשכת במשמעות.",
    icon: BookOpen,
    color: "bg-purple-100 hover:bg-purple-200"
  }, {
    id: "contact",
    title: "רסיטל",
    shortDescription: "צור קשר לשיחה והיכרות",
    fullDescription: "אם אחת מהתכניות, המודלים, הכתיבה הנרטיבית או תהליכי הליווי מעוררים בכם עניין ותרצו לחשוב יחד על התאמה לארגון, לצוות או לקהילה, אשמח לשיחה קצרה, אישית ובלתי מחייבת.",
    icon: Mail,
    color: "bg-green-100 hover:bg-green-200"
  }];
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 rtl">
      {/* Luxury Header Section */}
      <div className="relative overflow-hidden min-h-[70vh] flex items-center">
        {/* רקע יוקרתי מרובד */}
        <div className="absolute inset-0">
          {/* גרדיאנט בסיסי */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-100 via-cyan-200 to-teal-200"></div>
          
          {/* שכבת טקסטורה עדינה */}
          <div className="absolute inset-0 opacity-25">
            <div className="absolute top-20 left-20 w-96 h-96 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-teal-200/25 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-br from-purple-300/10 to-transparent rounded-full blur-3xl"></div>
          </div>
          
          {/* דוגמת גיאומטרית עדינה */}
          <div className="absolute inset-0 opacity-10">
            <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
              <defs>
                <pattern id="luxury-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                  <circle cx="10" cy="10" r="1" fill="currentColor" className="text-white/20" />
                </pattern>
              </defs>
              <rect width="100" height="100" fill="url(#luxury-pattern)" />
            </svg>
          </div>
          
          {/* אפקט בריק עליון */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
        </div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="text-center max-w-6xl mx-auto">
            {/* כותרת ראשית */}
            <div className="mb-8">
              <h1 className="font-bold text-blue-900 leading-tight mb-6 whitespace-nowrap" style={{fontSize: '50px'}}>
                תיק עבודות מקצועיות | רסיטל יצחקי
              </h1>
              
              {/* תת כותרת */}
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-blue-700 font-medium mb-8 leading-relaxed">חינוך, כתיבה והובלת תהליכים ארגוניים – מתוך ניסיון ניהולי, ראייה מערכתית ורגישות עמוקה לנפש האדם</h2>
            </div>
            
            {/* פסקת פתיחה */}
            <div className="mb-12 max-w-5xl mx-auto">
              <div className="text-right text-base sm:text-lg leading-7 text-slate-700 space-y-4">
                <p>
                  אני אשת חינוך, מנהלת לשעבר, כותבת ומפתחת תכנים ותהליכים חינוכיים‐ארגוניים. לאורך למעלה משני עשורים ליוויתי צוותים, מנהלים וקהילות בתהליכי שינוי, בפיתוח חוסן אישי וצוותי, תוך חיבור בין חשיבה פדגוגית, עומק רגשי ופעולות יישומיות.
                </p>
                <p>
                  בתיק העבודות שלפניכם תמצאו מבחר דוגמאות של מודלים, תכניות, השתלמויות ועוד. כל אלה מייצגות את תפיסת עולמי, את דרכי המקצועית ואת האופן שבו אני עובדת עם אנשים וארגונים.
                </p>
              </div>
            </div>
            
            {/* כפתור ניווט */}
            <div className="flex justify-center mb-12">
              <Button onClick={() => {
              const portfolioSection = document.getElementById('portfolio-sections');
              if (portfolioSection) {
                portfolioSection.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }} className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white text-base font-medium rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                היכרות עם תוצרים ופרוייקטים שפיתחתי
              </Button>
            </div>
            
            {/* כפתור לשיחה והיכרות */}
            <div className="flex justify-center mb-12">
              <Button onClick={() => navigate('/contact')} className="px-6 py-3 bg-white/70 hover:bg-white/90 text-blue-700 hover:text-blue-900 text-base font-medium rounded-lg shadow-sm border border-blue-200 transition-all duration-300 hover:shadow-md backdrop-blur-sm">
                לשיחה והיכרות
              </Button>
            </div>
            
            {/* שורה קצרה */}
            <div className="mb-16">
              <p className="text-sm text-slate-500 font-light tracking-wide">
                רסיטל יצחקי | הובלה חינוכית • כתיבה נרטיבית • פיתוח חוסן
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Portfolio Sections Grid */}
      <div id="portfolio-sections" className="container mx-auto px-6 py-16 relative">
        {/* אלמנט עיצובי רקע */}
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-gradient-to-br from-blue-100/30 to-transparent rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-gradient-to-br from-teal-100/30 to-transparent rounded-full blur-3xl -z-10"></div>
        
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-4">תחומי המומחיות שלי</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-teal-400 mx-auto rounded-full"></div>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {portfolioSections.map(section => {
          const IconComponent = section.icon;
          return <Card key={section.id} className={`portfolio-card cursor-pointer ${section.color} border border-white/50 hover:shadow-2xl transition-all duration-500 group relative overflow-hidden backdrop-blur-sm rounded-3xl`} onClick={() => navigate(`/${section.id}`)}>
            {/* אפקט בריק עדין */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl"></div>
            
            <CardHeader className="text-center pb-4 relative z-10 p-6">
              <div className="flex justify-center mb-4">
                <div className="p-4 rounded-full bg-white/80 group-hover:bg-white group-hover:scale-110 transition-all duration-300 shadow-lg">
                  <IconComponent className="w-8 h-8 text-slate-700 group-hover:text-blue-600 transition-colors duration-300" />
                </div>
              </div>
              <CardTitle className="text-lg sm:text-xl font-bold text-slate-800 mb-4 group-hover:text-slate-900 transition-colors duration-300 font-rounded">
                {section.title}
              </CardTitle>
            </CardHeader>
            <CardContent className="relative z-10 px-6 pb-6">
              {/* רק כותרת - ללא תיאור */}
            </CardContent>
          </Card>;
        })}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gradient-to-r from-slate-50 to-blue-50 py-12 border-t border-slate-200/50">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-teal-400 rounded-full"></div>
          </div>
          <p className="text-slate-600 text-lg font-medium">
            תיק עבודות מקצועי - רסיטל יצחקי
          </p>
          <p className="text-slate-500 text-sm mt-2">
            מקצועית בפיתוח תכנים
          </p>
        </div>
      </div>
    </div>;
};
export default Index;